import React from 'react';
import { Input } from 'antd';
import { CiSearch } from 'react-icons/ci';
import { CiCircleRemove } from 'react-icons/ci';
import './SearchBar.scss';

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/**
 * Styled search input component for the File Manager toolbar.
 * Renders an antd Input with a CiSearch suffix icon and a CiCircleRemove
 * clear button that appears on hover when the field has text.
 * Presentational only — search execution logic is external.
 */
export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder = 'SEARCH' }) => {
  return (
    <div className="search-bar-wrapper">
      <Input
        className="search-bar"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        suffix={
          <div className="search-bar__suffix">
            {value && <CiCircleRemove className="search-bar__clear" onClick={() => onChange('')} />}
            <CiSearch className="search-bar__icon" />
          </div>
        }
      />
    </div>
  );
};
